import React, { useState } from "react";
import { ConfigProvider, Tabs, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import InHouseLabs from './component/InhouseLabs';
import ExternalLabs from './component/ExternalHouse';
import OrderedLabs from './component/OrderedLabs';
import Results from './component/Results';
import { useStateGlobalContext } from "../../../../contexts/GlobalContext";
import { useUnsavedLabs } from "../../../../contexts/UnsavedLabsContext";
import "../../../../styles/unsaved-labs-modal.css";

const INHOUSE_LABS_TAB_KEY = "3";
const EXTERNAL_LABS_TAB_KEY = "4";

const TabPane = [
  {
    key: "1",
    label: "Ordered Labs",
    content: <OrderedLabs />,
  },
  {
    key: "2",
    label: "Lab Results",
    content: <Results />,
  },
  {
    key: INHOUSE_LABS_TAB_KEY,
    label: "New In-house Labs",
    content: null,
  },
  {
    key: EXTERNAL_LABS_TAB_KEY,
    label: "New External Labs",
    content: null,
  },
];

function Prescription() {
  const { profile } = useStateGlobalContext();
  const {
    hasUnsavedInhouseLabs,
    setHasUnsavedInhouseLabs,
    hasUnsavedExternalLabs,
    setHasUnsavedExternalLabs,
  } = useUnsavedLabs();

  const role = profile?.user_info?.[0]?.role;

  // Determine the default selected tab
  const defaultSelectedTab = "1";

  const [activeKey, setActiveKey] = useState(defaultSelectedTab);

  const handleTabChange = (key) => {
    if (key === activeKey) return;
    const leavingInhouseWithUnsaved =
      activeKey === INHOUSE_LABS_TAB_KEY && hasUnsavedInhouseLabs;
    const leavingExternalWithUnsaved =
      activeKey === EXTERNAL_LABS_TAB_KEY && hasUnsavedExternalLabs;
    if (leavingInhouseWithUnsaved || leavingExternalWithUnsaved) {
      Modal.confirm({
        icon: (
          <ExclamationCircleOutlined
            style={{ color: "#faad14", fontSize: 22 }}
          />
        ),
        title: (
          <span style={{ fontWeight: 600, fontSize: 16 }}>
            You have unsaved changes
          </span>
        ),
        content: (
          <p style={{ margin: 0, color: "#595959", lineHeight: 1.6 }}>
            Your lab form or list has data that hasn’t been saved. If you
            change tabs now, this data will be lost. Would you like to stay and
            save, or leave anyway?
          </p>
        ),
        okText: "Leave",
        cancelText: "Stay",
        onOk: () => setActiveKey(key),
        okButtonProps: {
          type: "primary",
        },
        cancelButtonProps: {
          style: {
            background: "#8c8c8c",
            borderColor: "#8c8c8c",
          },
        },
        className: "patient-tabs-unsaved-modal",
        centered: true,
      });
      return;
    }
    setActiveKey(key);
  };

  // Filter tabs based on the user's role
  const filteredTabPane =
    role === "nurse"
      ? TabPane.filter((tab) => tab.key === "1" || tab.key === "2") // Nurse can only see "Ordered Labs" and "Lab Results"
      : role === "biller"
      ? TabPane.filter((tab) => tab.key === "1") // Biller can only see "Ordered Labs"
      : TabPane; // All tabs for other roles

  return (
    <div>
      <ConfigProvider
        theme={{
          components: {
            Tabs: {
              fontSize: 13,
            },
          },
        }}
      >
        <Tabs activeKey={activeKey} type="card" onTabClick={handleTabChange}>
          {filteredTabPane.map((tab) => (
            <Tabs.TabPane key={tab.key} tab={tab.label}>
              {activeKey === tab.key &&
                (tab.key === INHOUSE_LABS_TAB_KEY ? (
                  <InHouseLabs onUnsavedChange={setHasUnsavedInhouseLabs} />
                ) : tab.key === EXTERNAL_LABS_TAB_KEY ? (
                  <ExternalLabs onUnsavedChange={setHasUnsavedExternalLabs} />
                ) : (
                  tab.content
                ))}
            </Tabs.TabPane>
          ))}
        </Tabs>
      </ConfigProvider>
    </div>
  );
}

export default Prescription;
